"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.users = void 0;
const data_access_1 = require("@resclick/data-access");
exports.users = {
    auth: {
        dto: data_access_1.UserAuthDto,
        path: '/auth',
        method: 'post',
        response: {},
    },
    create: {
        dto: data_access_1.UserCreateDto,
        method: 'post',
        path: '/users',
        response: {},
    },
    update: {
        dto: data_access_1.UserUpdateDto,
        method: 'put',
        params: ['id'],
        path: '/users/:id',
        response: {},
    },
    find: {
        method: 'get',
        path: '/users',
        response: {},
    },
    findOne: {
        method: 'get',
        params: ['id'],
        path: '/users/:id',
        response: {},
    },
    findCart: {
        method: 'get',
        path: '/carts',
        response: {},
    },
};
//# sourceMappingURL=users.api.js.map